import { lazy } from 'react';
import { INS_SUPER_ADMIN_ROUTES } from '../path';
import RouteTypes from '../route_types';
// Common Components
const CommonLayout = lazy(() => import('../../../voim/component/common/Layout'));
const NotFound = lazy(() => import('../../../voim/component/common/NotFound'));
const ChangePassword = lazy(() => import('../../../voim/component/common/ChangePassword'));
// Super Admin Components
// Dashboard
const Dashboard = lazy(() => import('../../../voim/component/admin/super-admin/dashboard'));
// Level 1
const TopLevelList = lazy(
    () => import('../../../voim/component/admin/super-admin/level-one/TopLevelList')
);
const AddTopLevel = lazy(
    () => import('../../../voim/component/admin/super-admin/level-one/AddTopLevel')
);
const ViewTopLevel = lazy(
    () => import('../../../voim/component/admin/super-admin/level-one/ViewTopLevel')
);
// Level 2
const SecondLevelList = lazy(
    () => import('../../../voim/component/admin/super-admin/level-two/SecondLevelList')
);
// School Admin
const SchoolAdminList = lazy(
    () => import('../../../voim/component/admin/super-admin/school-admin/SchoolAdminList')
);
// Student
const StudentList = lazy(
    () => import('../../../voim/component/admin/super-admin/student/StudentList')
);
// Educator
const TutorList = lazy(
    () => import('../../../voim/component/admin/super-admin/educator/TutorList')
);
// Financial Report
const FinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/FinancialReport')
);
const CustomFinancialReport = lazy(
    () => import('./../../../voim/component/common/Reports/CustomFinancialReport')
);
const PayoutReport = lazy(() => import('./../../../voim/component/common/Reports/PayoutReport'));
const LevelWiseReport = lazy(() => import('./../../../voim/component/common/LevelWiseReport'));

export default [
    // Dashboard
    {
        path: INS_SUPER_ADMIN_ROUTES.DASHBOARD,
        component: CommonLayout,
        pageComponent: Dashboard,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: true,
        active: 'dashboard',
        levelTitle: 'Admin',
        icon: 'material-icons',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.LEVEL_WISE_REPORT,
        component: CommonLayout,
        pageComponent: LevelWiseReport,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Dashboard',
        showNavigation: true,
        navMenu: false,
        active: 'dashboard',
        levelTitle: 'Admin',
    },
    // Level 1
    {
        path: INS_SUPER_ADMIN_ROUTES.TOP_LEVELS,
        component: CommonLayout,
        pageComponent: TopLevelList,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Level 1',
        showNavigation: true,
        navMenu: true,
        active: 'level-one',
        levelTitle: 'Admin',
        icon: 'fa fa-university',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.ADD_TOP_LEVEL,
        component: CommonLayout,
        pageComponent: AddTopLevel,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Add Level 1',
        showNavigation: true,
        navMenu: false,
        active: 'level-one',
        levelTitle: 'Admin',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.VIEW_TOP_LEVEL,
        component: CommonLayout,
        pageComponent: ViewTopLevel,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'View Level 1',
        showNavigation: true,
        navMenu: false,
        active: 'level-one',
        levelTitle: 'Admin',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.EDIT_TOP_LEVEL,
        component: CommonLayout,
        pageComponent: AddTopLevel,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Edit Level 1',
        showNavigation: true,
        navMenu: false,
        active: 'level-one',
        levelTitle: 'Admin',
    },
    // Level 2
    {
        path: INS_SUPER_ADMIN_ROUTES.SECOND_LEVELS,
        component: CommonLayout,
        pageComponent: SecondLevelList,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Level 2',
        showNavigation: true,
        navMenu: true,
        active: 'level-two',
        levelTitle: 'Admin',
        icon: 'fa fa-university',
    },
    // School Admin
    {
        path: INS_SUPER_ADMIN_ROUTES.SCHOOL_ADMINS,
        component: CommonLayout,
        pageComponent: SchoolAdminList,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Level 3',
        showNavigation: true,
        navMenu: true,
        active: 'level-three',
        levelTitle: 'Admin',
        icon: 'fa fa-university',
    },
    // Educator
    {
        path: INS_SUPER_ADMIN_ROUTES.TUTORS,
        component: CommonLayout,
        pageComponent: TutorList,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Educators',
        showNavigation: true,
        navMenu: true,
        active: 'educators',
        levelTitle: 'Admin',
        icon: 'fas fa-user-circle',
    },
    // Student
    {
        path: INS_SUPER_ADMIN_ROUTES.STUDENTS,
        component: CommonLayout,
        pageComponent: StudentList,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Students',
        showNavigation: true,
        navMenu: true,
        active: 'students',
        levelTitle: 'Admin',
        icon: 'fas fa-user-graduate',
    },
    // Financial Report
    {
        path: INS_SUPER_ADMIN_ROUTES.FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: FinancialReport,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: true,
        active: 'financial-reports',
        levelTitle: 'Admin',
        icon: 'fa-solid fa-money-bill-wave',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.CUSTOM_FINANCIAL_REPORT,
        component: CommonLayout,
        pageComponent: CustomFinancialReport,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Admin',
    },
    {
        path: INS_SUPER_ADMIN_ROUTES.PAYOUT_REPORT,
        component: CommonLayout,
        pageComponent: PayoutReport,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Financial Reports',
        showNavigation: true,
        navMenu: false,
        active: 'financial-reports',
        levelTitle: 'Admin',
    },
    // Change Password
    {
        path: INS_SUPER_ADMIN_ROUTES.CHANGE_PASSWORD,
        component: CommonLayout,
        pageComponent: ChangePassword,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Change Password',
        showNavigation: false,
        navMenu: false,
        active: 'Change Password',
        levelTitle: 'Admin',
    },
    // Not Found
    {
        path: '*',
        component: NotFound,
        roleType: RouteTypes.INS_SUPER_ADMIN,
        title: 'Not Found',
        active: 'Not Found',
        levelTitle: 'Admin',
    },
];
